import { AnalyticsMeal, Product } from '../platforms/adobe-analytics/models';

export class ViewBagEvent {
  name = 'ViewBagEvent';
  constructor(
    public readonly meals: AnalyticsMeal,
    public readonly upsellItems?: Product[]
  ) {}
}
